<template>
    <div id="OpenCase">
        <div class="Top_KaiXiang">
            <div class="OpenCase-T">
                <div class="OpenCase-T-box" :class="this.ShengFu | GuoLv">
                    <div class="BoxState" v-show="status == 0">
                        <div class="ready" v-show="content != undefined">
                            <img class="tick" src="@/assets/images/battlePage/ready.png" alt="">
                            <img class="rotation_img" src="@/assets/images/battlePage/rotation_img.png" alt="">
                            <span>准备完毕</span>
                        </div>

                        <template v-if="create_user_id!=user.id">
                            <div class="ready" v-show="content == undefined" @click="PostArena_Join">
                                <img class="waitting" src="@/assets/images/battlePage/waitting.png" alt="">
                                <span>立即加入</span>
                            </div>
                        </template>
                        <template v-else>
                            <div class="ready" v-show="content == undefined" @click="PostArena_Robots">
                                <img class="waitting" src="@/assets/images/battlePage/waitting.png" alt="">
                                <span>邀请机器人</span>
                            </div>
                        </template>
                    </div>
                    
                    <div class="LuckDraw" v-show="status !== 0">
                        <div class="WinOrLose" v-show="Lieutenant_general == true">
                            <img class="win_item" v-if="ShengLiOrShiBai == '胜利'" src="@/assets/images/battlePage/win.png"
                                alt="">
                            <img class="lost_item" v-else src="@/assets/images/battlePage/lose.png" alt="">

                        </div>

                        <!---绘制抽奖动画-->
                        <div class="container" :key='Draw_times' v-show="Lieutenant_general == false">
                            <div class="Visible" :style="{ 'margin-top': '-' + (this.Height * this.Frequency + 'px') }">
                                <div class="GameBox" v-for="(item, index) in Box_arr" :key='index'>
                                    <img :src="item.cover" alt="">
                                </div>
                            </div>
                        </div>

                        <!---线的绘制-->
                        <div class="box_open_arrow"></div>
                    </div>

                    
                </div>
            </div>

            <div class="OpenCase-C">
                <div class="battle_person" v-if="content != undefined">
                    <div class="current_money">
                        <div class="accumulate">
                            轮次获得:
                            <div class="money_style">
                                <img src="@/assets/images/new-ui/9coin.png" alt=""
                                    style="width: 16px; height: 16px; margin-right: 2px;">
                                    <countTo :startVal='startVal' :endVal='endVal' :duration='2000' :decimals="2"></countTo>
                            </div>
                        </div>
                    </div>
                    <div class="person_head_img">
                        <div class="person_xxx">
                            <div class="head_bg" :class="content.anchor_icon | VipLv">
                            </div>
                            <img class="head" :src="content.avatar | ImgRoute" alt="">
                        </div>
                        <p>{{ content.name }}</p>
                    </div>
                </div>

            </div>
        </div>
        <div class="OpenCase-B" v-if="content != undefined">
            <div class="reward" v-for="(item, index) in Prize_column" :key="index">
                <div class="pic">
                    <img :src="item.cover" alt="">
                </div>

                <div class="product_msg">
                    <div class="money">
                        <img src="@/assets/images/new-ui/9coin.png" alt="">
                        <span>{{ item.bean }}</span>
                    </div>
                    <div class="name">
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MP3 from '@/assets/audios/open.mp3'
import {
    Arena_Join,
    Arena_Robots
} from '@/network/api.js'
import countTo from 'vue-count-to';
import {mapActions, mapState} from 'vuex'
export default {
    name: 'OpenCase',
    props: {
        content: {
            type: Object,
        },

        itemInfo: {
            type: Object
        },

        game_arena_id: {
            type: String
        },
        InDex: {
            type: Number
        },
        status: {
            type: Number
        },
        create_user_id:{
            type: Number
        },
        game_arena_data: {
            type: Object
        },
    },
    data() {
        return {
            amount: 0,
            GoldCoin: 0.00,
            prizeShow: false,
            Box_arr: [],
            Height: 160,    //GameBox 的height
            Frequency: 0,

            ShengFu: '',

            Prize_column: [],

            startVal: 0,
            endVal: 0,

            ShengLiOrShiBai: '',

            endValNum: 0,

            clearTimeSet: null,

            Draw_times: 0,

            Lieutenant_general: false,

            ZuiZhongJiangPin_Arr: []
        }
    },


    filters: {
        ImgRoute(str) {
            if (str.indexOf(localStorage.getItem('static_file_url')) != -1) {
                return str
            } else {
                return localStorage.getItem('static_file_url') + str
            }
        },

        GuoLv(val) {
            if (val == 'ShengLi') {
                return 'active'
            } else if (val == 'ShiBai') {
                return 'ShiBai'
            } else {
                return ''
            }
        },
        VipLv(val){
            if (val == 1) {
                return 'anchor';    ///主播
            } else if (val == 2) {
                return 'gf';    ///官方
            } else {
                return ''
            }
        }



    },

    components: {
        countTo
    },

    methods: {
        GetVipIcon(level) {
            if (level == 1) {
                return require('@/assets/images/vip/VIP-1.png');
            } else if (level == 2) {
                return require('@/assets/images/vip/VIP-2.png');
            } else if (level == 3) {
                return require('@/assets/images/vip/VIP-3.png');
            } else if (level == 4) {
                return require('@/assets/images/vip/VIP-4.png');
            } else if (level == 5) {
                return require('@/assets/images/vip/VIP-5.png');
            }
            else if (level == 6) {
                return require('@/assets/images/vip/VIP-6.png');
            }
            else if (level == 7) {
                return require('@/assets/images/vip/VIP-7.png');
            }
            else if (level == 8) {
                return require('@/assets/images/vip/VIP-8.png');
            }
            else if (level == 9) {
                return require('@/assets/images/vip/VIP-9.png');
            }
            else if (level == 10) {
                return require('@/assets/images/vip/VIP-10.png');
            }
            else if (level == 11) {
                return require('@/assets/images/vip/VIP-11.png');
            }
            else if (level == 12) {
                return require('@/assets/images/vip/VIP-12.png');
            }
            return require('@/assets/images/vip/VIP-1.png');
        },

        EndOperation() {
    
            if (this.content != undefined && this.$route.query.Code != 1) {
                for (let i = 0; i < this.content.game_award.length; i++) {
                    this.Prize_column.push(this.content.game_award[i].box_award)
                    this.endValNum = this.endValNum + Number(this.content.game_award[i].box_award.bean)
                }
             }
        },



        Prize_replacement(val) {
            this.Box_arr[20] = val
            this.getsetTime()
        },

        StartTheDraw() {

            this.toParent()
            this.Frequency = 0
            this.Lieutenant_general = false
            let arr = this.game_arena_data.game_arena_box[this.Draw_times].box_award.concat(this.game_arena_data.game_arena_box[
                this.Draw_times].box_award.concat(this.game_arena_data.game_arena_box[this.Draw_times].box_award))

            function randSort1(arr) {
                for (let i = 0, len = arr.length; i < len; i++) {
                    let rand = parseInt(Math.random() * len)
                    let temp = arr[rand]
                    arr[rand] = arr[i]
                    arr[i] = temp
                }
                return arr
            }
            
            while(arr.length < 22){
                let rand = parseInt(Math.random() * arr.length)
                let temp = arr[rand]
                arr.push(temp);
            }

            this.Box_arr = randSort1(arr)

            let JiangPin_Arr = []
            for (let i = 0; i < this.game_arena_data.game_arena_player.length; i++) {
                JiangPin_Arr[i] = undefined
            }

            for (let k = 0; k < this.game_arena_data.game_arena_player.length; k++) {
                JiangPin_Arr[Number(this.game_arena_data.game_arena_player[k].seat)] = this.game_arena_data.game_arena_player[k]
            }


            this.ZuiZhongJiangPin_Arr = JiangPin_Arr

            this.Prize_replacement(this.ZuiZhongJiangPin_Arr[this.content.seat].game_award[this.Draw_times].box_award)




            setTimeout(() => {
                this.amount = Number(this.amount) + Number(this.ZuiZhongJiangPin_Arr[this.content.seat].game_award[this.Draw_times]
                    .box_award.bean);
                this.Prize_column.push(this.ZuiZhongJiangPin_Arr[this.content.seat].game_award[this.Draw_times].box_award)
            }, 4500)
        },

        Final_Page() {
            if (this.itemInfo.win_user_id != null) {
                this.Lieutenant_general = true
                this.$root.eventHub.$emit('vs_award_show');
                if (this.itemInfo.win_user_id.length == 1) {
                    let A_Arr = this.itemInfo.win_user_id.find((v) => {
                        return v == this.content.user_id
                    })
                    if (A_Arr != undefined) {
                        this.ShengLiOrShiBai = '胜利'
                        this.ShengFu = 'ShengLi'
                        let B_Arr = []
                        for (let a = 0; a < this.itemInfo.game_arena_player.length; a++) {
                            B_Arr = B_Arr.concat(this.itemInfo.game_arena_player[a].game_award)
                        }

                        let C_Arr = []
                        let D_Num = 0
                        for (let b = 0; b < B_Arr.length; b++) {
                            C_Arr.push(B_Arr[b].box_award)
                            D_Num = Number(D_Num) + Number(B_Arr[b].box_award.bean)
                        }

                        this.Prize_column = C_Arr
                        this.endValNum = D_Num.toFixed(2)
                    } else {
                        this.ShengLiOrShiBai = '凉凉奖励'
                        this.ShengFu = 'ShiBai'
                        this.endValNum = 0.01

                        this.Prize_column = [{
                            cover: require('@/assets/images/PublicImg/LL.png'),
                            name: '凉凉奖励',
                            bean: '0.01'
                        }]
                    }
                } else {
                    let D_Arr = this.itemInfo.win_user_id.find((v) => {
                        return v == this.content.user_id
                    })
                    if (D_Arr != undefined) {
                        this.ShengLiOrShiBai = '胜利'
                        this.ShengFu = 'ShengLi'

                        let E_Arr = []
                        let Y_Item = this.itemInfo.game_arena_player.filter((v) => {
                            return v.id == this.content.id
                        })

                        for (let d = 0; d < Y_Item[0].game_award.length; d++) {
                            E_Arr.push(Y_Item[0].game_award[d].box_award)
                        }
                        this.Prize_column = E_Arr

                        this.WeiZhongJiang(this.itemInfo.win_user_id)

                    } else {
                        this.ShengLiOrShiBai = '失败'
                        this.ShengFu = 'ShiBai'
                        this.endValNum = 0.01

                        this.Prize_column = [{
                            cover: require('@/assets/images/PublicImg/LL.png'),
                            name: '凉凉奖励',
                            bean: '0.01'
                        }]
                    }
                }
            }

        },

        WeiZhongJiang(arr) {
            let G_Arr = []
            if (arr.length == 2) {
                G_Arr = this.itemInfo.game_arena_player.filter((v) => {
                    return v.user_id !== arr[0] && v.user_id !== arr[1]
                })
                this.ZJinE(G_Arr)
            } else if (arr.length == 3) {
                G_Arr = this.itemInfo.game_arena_player.filter((v) => {
                    return v.user_id !== arr[0] && v.user_id !== arr[1] && v.user_id !== arr[2]
                })
                this.ZJinE(G_Arr)
            }
        },

        ZJinE(arr) {
            let D_Num = 0
            for (let b = 0; b < arr.length; b++) {
                for (let k = 0; k < arr[b].game_award.length; k++) {
                    D_Num = D_Num + Number(arr[b].game_award[k].box_award.bean)
                }
            }

            let Z_Num = D_Num.toFixed(2)
            let ZhongJiangNum = this.itemInfo.win_user_id.length
            let Qian = Number(Z_Num) / Number(ZhongJiangNum)

            let P_Num = 0
            let Y_Item = this.itemInfo.game_arena_player.filter((v) => {
                return v.id == this.content.id
            })


            for (let a = 0; a < Y_Item[0].game_award.length; a++) {
                P_Num = P_Num + Number(Y_Item[0].game_award[a].box_award.bean)
            }

            let H_Num = Number(P_Num) + Qian
            this.endValNum = H_Num.toFixed(2)
        },

        PostArena_Join() {
            Arena_Join(this.game_arena_id, this.InDex).then((res) => {
                console.log(res);
            })
        },
        ///邀請機器人
        PostArena_Robots(){
            Arena_Robots(this.game_arena_id, this.InDex).then((res) => {
                console.log(res);
            })
        },

        toParent() {
            this.$emit('fromChild', {
                id: this.game_arena_id,
                Draw_times: this.Draw_times
            })
        },

        getsetTime() {
            this.clearTimeSet = setInterval(() => {
                this.Frequency += 1
            }, 100);
        },

        getclearTime() {
            clearTimeout(this.clearTimeSet)
        },

        childClick(val) {
            this.$emit('childByValue', val)
        },

        ...mapActions([
            'GetroundNum'
        ])
    },

    computed: {
        ...mapState([
            'JieShuVsData',
            'user'
        ])
    },

    watch: {
        Frequency(val) {
            if (val == 20) {
                this.getclearTime()
            }
        },

        endValNum(val) {
            this.endValNum = Number(val).toFixed(2)
        },

        amount(val) {
            this.endVal = Number(val.toFixed(2))
        },

        endVal(val) {
            setTimeout(() => {
                this.startVal = val
                this.Draw_times = this.Draw_times + 1;
            }, 2000) ///2000
        },

        game_arena_data(val) {
            this.game_arena_data = val;
            setTimeout(() => {
                this.StartTheDraw()
            }, 200)

        },
        content(val) {
            this.EndOperation()
        },

        Draw_times(val) {
            if (val == this.game_arena_data.box_num) {
                this.childClick('结束')
                this.Lieutenant_general = true
                this.$root.eventHub.$emit('vs_award_show');
            } else {
                this.StartTheDraw()
                this.toParent()
            }

        },

        itemInfo(val) {
            this.itemInfo = val
            this.Final_Page()
        }
    }
}
</script>

<style lang="scss">
#OpenCase {
    @keyframes pulse {
        0% {
            transform: scaleX(1);
        }

        50% {
            transform: scale3d(1.1, 1.1, 1.1);
        }

        100% {
            transform: scaleX(1);
        }
    }

    flex: 1;
    margin: 0 4px;
    user-select: none;

    .Top_KaiXiang {}
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        z-index: 15;
    }


    .OpenCase-T {
        width: 100%;
        height: 180px;
        border-radius: 30px 30px 0 0;
        overflow: hidden;
        background-color: #170f38;
        background-image: url(../../../assets/images/battlePage/public_title.png);
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        .OpenCase-T-box {
            width: 100%;
            height: 100%;
            position: relative;

            .BoxState {
                width: 100%;
                height: 100%;

                .ready {
                    position: relative;
                    z-index: 2;

                    .tick {
                        position: absolute;
                        z-index: 3;
                        width: 40px;
                        height: auto;
                        object-fit: contain;
                        margin: 0 auto;
                        left: 0;
                        right: 0;
                        top: 60px;
                    }

                    .rotation_img {
                        position: absolute;
                        z-index: 1;
                        height: auto;
                        object-fit: contain;
                        margin: 0 auto;
                        left: 0;
                        right: 0;
                        top: 32px;
                        animation: rotate 3s linear infinite;

                        img {
                            width: 80px;
                            height: 80px;
                        }
                    }

                    .waitting {
                        position: absolute;
                        z-index: 1;
                        height: auto;
                        object-fit: contain;
                        margin: 0 auto;
                        left: 0;
                        right: 0;
                        top: 32px;

                        img {
                            width: 80px;
                            height: 80px;
                        }
                    }

                    span {
                        position: absolute;
                        font-size: 14px;
                        text-align: center;
                        color: #fff;
                        text-shadow: 0 0 2px #db00ff, 0 0 6px #8000ff, 0 0 2px #9712ff;
                        left: 0;
                        right: 0;
                        top: 120px;

                    }
                }
            }

            .LuckDraw {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                .WinOrLose {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    background-image: url(../../../assets/images/battlePage/kuang_bg.png);
                    background-position: 50%;
                    background-repeat: no-repeat;
                    background-size: auto 100%;

                    .lost_item {
                        width: 100%;
                        height: 100%;
                        max-width: 65%;
                        max-height: 65%;
                    }

                    .win_item {
                        width: 70%;
                        height: 70%;
                        animation-duration: 2s;
                        animation-iteration-count: infinite;
                        animation-name: pulse;
                        animation-timing-function: ease-in-out;
                    }
                }

                .container {
                    width: 60%;
                    height: 160px;
                    padding-top: -20px;
                    mask-image: linear-gradient(0deg, rgba(25, 25, 25, 0) 4%, #000 60%, rgba(25, 25, 25, 0) 96%);

                    .Visible {
                        width: 100%;
                        transition: 3s cubic-bezier(0, 0, 0.28, 1);
                    }

                    .GameBox {
                        width: 100%;
                        height: 160px;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        img {
                            max-width: 80%;
                            max-height: 80%;
                        }
                    }
                }

                .box_open_arrow {
                    position: absolute;
                    z-index: 9;
                    //height: 1px;
                    background: #2ffaf8;
                    left: 0;
                    width: 100%;
                    &::after {
                        content: "";
                        top: calc(50% - 30px);
                        width: 60px;
                        height: 60px;
                        left: -15px;
                        position: absolute;
                        background: url(../../../assets/images/battlePage/leftbtn_s.png) no-repeat 50%;
                        transform: rotate(360deg);
                        background-size: contain;
                    }
                    &::before {
                        content: "";
                        top: calc(50% - 30px);
                        width: 60px;
                        height: 60px;
                        right: -15px;
                        position: absolute;
                        transform: rotate(180deg);
                        background: url(../../../assets/images/battlePage/leftbtn_s.png) no-repeat 50%;
                        background-size: contain;
                    }
                }
            }
        }
    }

    .OpenCase-C {
        width: 100%;
        background-image: url(../../../assets/images/battlePage/bg10.png);
        background-size: 100% 100%;

        .battle_person {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 200px;
            padding-top: 25px;

            .current_money {
                position: absolute;
                top: 5px;
                color: #878b91;
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                padding: 0 15px;
                font-size: 15px;

                .accumulate {
                    display: flex;
                    align-items: center;

                    .money_style {
                        display: flex;
                        align-items: center;

                        span {
                            margin-top: 3px;
                            font-size: 15px;
                            font-family: "Oxanium";
                            color: #fff;
                        }

                    }

                }
            }

            .person_head_img {
                .person_xxx {
                    margin: 0 auto;
                    position: relative;
                    width: 120px;
                    height: 120px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    ///vip背景
                    .head_bg {
                        position: absolute;
                        width: 90%;
                        height: 100%;
                        &::before {
                            content: "";
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            background-size: contain;
                            background-repeat: no-repeat;
                            background-position: 50%;
                            left: 50%;
                            top: calc(50% + 4px);
                            transform: translate(-50%, -50%);
                            z-index: 3;
                        }

                        &.gf{
                            &::before {
                                background-image: url(../../../assets/images/vip/gf.png);
                            }
                        }
                        &.anchor{
                            &::before {
                                background-image: url(../../../assets/images/vip/anchor.png);
                            }
                        }

                    }

                    ///用户头像
                    .head {
                        width: 64%;
                        height: 64%;
                        border-radius: 50%;
                        z-index: 2;
                    }

                }

                p {
                    margin-top: 4px;
                    max-width: 100%;
                    text-align: center;
                    font-size: 14px;
                    color: #fff;
                    text-shadow: 0 0 3px rgba(219, 0, 255, .86);
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }

        }
    }

    .OpenCase-B {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        box-sizing: border-box;

        .reward {
            width: 49.8%;
            background-color: #1e1543;
            border-radius: 4px;
            margin-top: 2px;

            .pic {
                width: 100%;
                height: 100px;
                background-image: url(../../../assets/images/battlePage/get_product_bg.png);
                background-position: 50%;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    max-width: 90%;
                    max-height: 90%;
                    object-fit: contain;
                }
            }

            .product_msg {
                margin-top: 2px;
                .money {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        width: 16px;
                        height: 16px;
                        object-fit: contain;
                        position: relative;
                        top: -1px;
                    }
                    span {
                        font-family: "Oxanium";
                        font-weight: 500;
                        font-size: 15px;
                        color: #fff5ff;
                        text-shadow: 0 0 1.74773px #9934ff;
                    }
                }

                .name {
                    font-size: 13px;
                    color: #b6b6b6;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 90%;
                    margin: 5px auto;
                    text-align: center;
                }

            }

        }
    }
}</style>
